import React, { useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import Header from '../cabecalho/Cabecalho';
import Menu from '../menu/Menu';
import Rodape from '../rodape/Rodape';
import Titulo from '../titulo/Titulo';

// ---------------------------------------------------------------------------
// Layout (padrão das páginas admin)
// ---------------------------------------------------------------------------
const CorpoDaPagina = styled.div`
  margin-left: 200px;
  padding-top: 85px;
  padding-bottom: 50px;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;

  @media (max-width: 1200px) { margin-left: 60px; }
  @media (max-width: 767.98px) { margin-left: 0; }
`;

const TituloContainer = styled.div`
  padding: 0 24px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;

const ContentContainer = styled.div`
  flex: 1;
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

// ---------------------------------------------------------------------------
// Card principal
// ---------------------------------------------------------------------------
const Card = styled.div`
  width: 90%;
  max-width: 480px;
  padding: 32px 40px;
  border: 1px solid #c0392b;
  border-radius: 10px;
  background: #fffafa;
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.10);
`;

const CardTitle = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  color: #c0392b;
  margin: 0 0 6px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CardDesc = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 0.85rem;
  color: #666;
  margin: 0 0 24px 0;
  line-height: 1.5;
`;

const Label = styled.label`
  display: block;
  font-family: 'Roboto', sans-serif;
  font-size: 0.82rem;
  font-weight: 500;
  color: #444;
  margin-bottom: 5px;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${({ $error }) => ($error ? '#c0392b' : '#ccc')};
  border-radius: 6px;
  font-family: 'Roboto', sans-serif;
  font-size: 0.95rem;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 16px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #008080;
  }
`;

const Botao = styled.button`
  width: 100%;
  padding: 11px;
  background: ${({ disabled }) => (disabled ? '#aaa' : '#008080')};
  color: #fff;
  border: none;
  border-radius: 6px;
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background 0.2s;
  margin-top: 4px;

  &:hover:not(:disabled) {
    background: #006666;
  }
`;

const Erro = styled.p`
  background: #fff0f0;
  border: 1px solid #f5c6c6;
  border-radius: 6px;
  color: #c0392b;
  font-family: 'Roboto', sans-serif;
  font-size: 0.85rem;
  padding: 10px 14px;
  margin-top: 16px;
`;

const Sucesso = styled.div`
  background: #f0fff4;
  border: 1px solid #a3d9b1;
  border-radius: 6px;
  padding: 16px;
  margin-top: 16px;
`;

const SucessoTexto = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 0.85rem;
  color: #276749;
  margin: 0 0 12px 0;
`;

const LinkSwagger = styled.a`
  display: inline-block;
  background: #008080;
  color: #fff;
  padding: 10px 20px;
  border-radius: 6px;
  text-decoration: none;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  transition: background 0.2s;

  &:hover {
    background: #006666;
  }
`;

const LinkSwaggerBotao = styled.button`
  display: inline-block;
  background: #008080;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #006666;
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #f0d0d0;
  margin: 24px 0 20px 0;
`;

// ---------------------------------------------------------------------------
// Componente
// ---------------------------------------------------------------------------
const SwaggerAdmin = () => {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [palavraPasse, setPalavraPasse] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [swaggerUrl, setSwaggerUrl] = useState('');

  const mensagensErro = {
    400: 'Preencha todos os campos obrigatórios.',
    401: 'Credenciais ou palavra-passe inválidas.',
    403: 'Seu usuário não possui perfil de administrador.',
    503: 'Configuração de segurança não encontrada. Contate o suporte.',
  };

  const getApiUrl = () => {
    const configuredApiUrl = process.env.REACT_APP_API_URL?.trim() || '';
    const normalizedApiUrl = configuredApiUrl.replace(/\/+$/, '');

    if (!/^https?:\/\//i.test(normalizedApiUrl)) {
      throw new Error('Configuração inválida de REACT_APP_API_URL.');
    }

    return normalizedApiUrl;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setSwaggerUrl('');

    if (!usuario.trim() || !senha.trim() || !palavraPasse.trim()) {
      setErro('Preencha todos os campos.');
      return;
    }

    setCarregando(true);
    try {
      const apiUrl = getApiUrl();
      const endpoint = new URL('/auth/gerar-token-admin', `${apiUrl}/`).toString();

      const { data } = await axios.post(endpoint, {
        usuario: usuario.trim(),
        senha,
        palavraPasse: palavraPasse.trim(),
      });
      setSwaggerUrl(data.swaggerUrl);
    } catch (err) {
      if (err?.message === 'Configuração inválida de REACT_APP_API_URL.') {
        setErro('Configuração da API inválida no ambiente de homologação.');
        return;
      }

      const status = err?.response?.status;
      const backendErro = err?.response?.data?.erro;
      setErro(backendErro || mensagensErro[status] || 'Erro inesperado. Tente novamente.');
    } finally {
      setCarregando(false);
    }
  };

  const handleReset = () => {
    setSwaggerUrl('');
    setErro('');
    setSenha('');
    setPalavraPasse('');
  };

  const abrirSwagger = () => {
    const novaJanela = window.open(swaggerUrl, '_blank', 'noopener,noreferrer');

    if (!novaJanela) {
      setErro('O navegador bloqueou a abertura automática. Use o link exibido abaixo.');
    }
  };

  return (
    <>
      <Header />
      <Menu />
      <CorpoDaPagina>
        <TituloContainer>
          <Titulo texto="Acesso ao Swagger" />
        </TituloContainer>
        <ContentContainer>
          <Card>
            <CardTitle>
              🔒 Documentação da API
            </CardTitle>
            <CardDesc>
              Exclusivo para administradores. Informe suas credenciais e a
              palavra-passe de administradores para gerar um token e acessar
              a documentação.
            </CardDesc>

            {!swaggerUrl ? (
              <form onSubmit={handleSubmit} autoComplete="off">
                <Label htmlFor="swagger-usuario">Usuário</Label>
                <Input
                  id="swagger-usuario"
                  type="text"
                  placeholder="Seu usuário de acesso"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                  autoComplete="username"
                  disabled={carregando}
                />

                <Label htmlFor="swagger-senha">Senha</Label>
                <Input
                  id="swagger-senha"
                  type="password"
                  placeholder="Sua senha"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  autoComplete="current-password"
                  disabled={carregando}
                />

                <Divider />

                <Label htmlFor="swagger-palavra-passe">Palavra-passe de administradores</Label>
                <Input
                  id="swagger-palavra-passe"
                  type="password"
                  placeholder="Frase secreta compartilhada entre admins"
                  value={palavraPasse}
                  onChange={(e) => setPalavraPasse(e.target.value)}
                  autoComplete="off"
                  disabled={carregando}
                />

                <Botao type="submit" disabled={carregando}>
                  {carregando ? 'Verificando...' : 'Gerar token e abrir Swagger'}
                </Botao>

                {erro && <Erro>{erro}</Erro>}
              </form>
            ) : (
              <Sucesso>
                <SucessoTexto>
                  ✅ Token gerado com sucesso! Clique no botão abaixo para abrir
                  a documentação. O link expira em 8 horas.
                </SucessoTexto>
                <LinkSwaggerBotao type="button" onClick={abrirSwagger}>
                  Abrir Swagger
                </LinkSwaggerBotao>
                <br />
                <Botao
                  type="button"
                  onClick={handleReset}
                  style={{ marginTop: '12px', background: '#666' }}
                >
                  Gerar novo token
                </Botao>
              </Sucesso>
            )}
          </Card>
        </ContentContainer>
        <Rodape />
      </CorpoDaPagina>
    </>
  );
};

export default SwaggerAdmin;
